
import { v1 as UUID } from "uuid";
import _this from '@/main.js'
const Paper = function () {
    this.title = `<p style="text-align: center;"><span style="font-size: 20px"><strong><span style="color: #10ab97;">${_this.$t('Paper.Title')}</span></strong></span></p>` // 项目名称（问卷）
    this.depict = _this.$t('Paper.Depict') // 项目描述
    this.pageCount = 0 // 页码类型总数
    this.quesCount = 0 // 试题类型总数
    this.quesAtive = '' // 当前选中项
	this.endPageType = 0 // 完成的状态 0 正常 1 提前
	this.endPageNormalMsg = `<p style="text-align: center;">${_this.$t('Paper.endPageNormalMsg')}</p>` // 正常完成 结束页提示语
	this.endPageAdvanceMsg = `<p style="text-align: center;">${_this.$t('Paper.endPageAdvanceMsg')}</p>` // 提前完成 结束页提示语
    this.questionsList = new Array()
    this.createQuestion = function (ques) {
        // let checkboxArr = [] // 存储多选的答案
        let question = new Question()
        question.qid = UUID()
        let quesinfoArr = [...ques]
        // 输入类逻辑
        let logicalSettings = {
            num: 0,
            jump: { // 跳转条件
                type: 0, // 0无条件 1选择某一项
                logicList: []
            },
            show: [],
            // { // 显示条件
            //     condition: 1, // 1 全部 2 任意
            //     conditionList: [{
            //         questionId: '', // 题目
            //         questionState: 3, // 题目状态
            //     }]
            // },
            quesBound: [], // 绑定显示条件的试题
        }
        // 选择类逻辑
        let logicalSettings2 = {
            num: 0,
            jump:{
                type: 0, // 0无条件 1选择某一项
                logicList: []
            },
            show: [],
            // {
            //     condition: 1, // 1 全部 2 任意
            //     conditionList: [
            //         {
            //             questionId: '', // 题目
            //             questionState: 1, // 题目状态
            //             optionId: 0 // 状态条件（题目状态是选中时）
            //         }
            //     ]
            // },
            quesBound: []
        }
        
        // 试题添加属性
        quesinfoArr.forEach((info, index) => {
            if (index == 0) {
                // debugger
                if (info.indexOf(`【${_this.$t('main.SingleChoice')}】`) != -1) {
                    info = info.indexOf(`【${_this.$t('main.SingleChoice')}】`) > 0 ? info.replace(`【${_this.$t('main.SingleChoice')}】`, '') : info
                    question.questionsName = info
                    question.questionsTypeId = '8'
                    question.noAnswer = ''
                    question.optionIfRandom = 0 // 选项随机排列
                    question.ifFixedLastOption = 0 // 固定最后一个选项
                    question.cutType = 3 // 单选
                    question.showcolnum = 1 // 选项布局
                    question.relation = [{id: ''}] // 试题关联选项的试题id
                    question.associated = [] // 被关联的试题id
                    question.groupingOptionList = [] // 分组
                    question.logicalSettings = logicalSettings2
                    question.scoreOrNot = 0
                    question.isClosedLoop = 0
                }else if (info.indexOf(`【${_this.$t('main.MultipleChoiceQuestions')}】`) != -1) {
                    info = info.indexOf(`【${_this.$t('main.MultipleChoiceQuestions')}】`) > 0 ? info.replace(`【${_this.$t('main.MultipleChoiceQuestions')}】`, '') : info
                    question.questionsName = info
                    question.questionsTypeId = '10'
                    question.noAnswer = []
                    question.optionIfRandom = 0 // 选项随机排列
                    question.ifFixedLastOption = 0 // 固定最后一个选项
                    question.cutType = 4 // 多选
                    question.showcolnum = 1 // 选项布局
                    question.relation = [{id: ''}] // 试题关联选项的试题id
                    question.associated = [] // 被关联的试题id
                    question.maxOptionsNum = 0 // 最多可选几项 0(不限)
                    question.minOptionsNum = 0 // 最多可选几项 0(不限)
                    question.groupingOptionList = [] // 分组
                    question.logicalSettings = logicalSettings2
                }else if (info.indexOf(`【${_this.$t('main.TrueOrFalse')}】`) != -1) {
                    info = info.indexOf(`【${_this.$t('main.TrueOrFalse')}】`) > 0 ? info.replace(`【${_this.$t('main.TrueOrFalse')}】`, '') : info
                    question.questionsName = info
                    question.questionsTypeId = '12'
                    question.noAnswer = ''
                    question.logicalSettings = logicalSettings2
                    question.scoreOrNot = 0
                    question.isClosedLoop = 0
                }else if (info.indexOf(`【${_this.$t('main.fillInTheBlanks')}】`) != -1) {
                    info = info.indexOf(`【${_this.$t('main.fillInTheBlanks')}】`) > 0 ? info.replace(`【${_this.$t('main.fillInTheBlanks')}】`, '') : info
                    question.questionsName = info
                    question.questionsTypeId = '5'
                    question.noAnswer = ''
                    question.format = 0 // 内容限制
                    question.inputHeight = '小' // 输入框高度
                    question.maxNum = 0
                    question.minNum = 0
                    question.decimalPlaces = 0
                    question.logicalSettings = logicalSettings
                }else if (info.indexOf(`【${_this.$t('main.ParagraphDescription')}】`) != -1) {
                    question.questionsName = info.replace(`【${_this.$t('main.ParagraphDescription')}】`, '')
                    question.questionsTypeId = '25'
				    question.quesCode = '' // 问题编码
                    question.logicalSettings = {
                        num: 0,
                        show: [],
                        // { // 显示条件
                        //     condition: 1, // 1 全部 2 任意
                        //     conditionList: [{
                        //         questionId: '', // 题目
                        //         questionState: 3, // 题目状态
                        //     }]
                        // },
                        quesBound: [], // 绑定显示条件的试题
                    }
                } else if (info.indexOf(`【${_this.$t('ImportQuestion.ConclusionNormalEnd')}】`) != -1) {
                    this.endPageType = 0
                    this.endPageNormalMsg = info.replace(`【${_this.$t('ImportQuestion.ConclusionNormalEnd')}】`, '')
                    console.log('this.endPageNormalMsg :>> ', this.endPageNormalMsg);
                } else if (info.indexOf(`【${_this.$t('ImportQuestion.ConclusionEarlyTermination')}】`) != -1) {
                    this.endPageType = 1
                    this.endPageAdvanceMsg = info.replace(`【${_this.$t('ImportQuestion.ConclusionEarlyTermination')}】`, '')
                } else {
                    question.questionsName = info
                    question.questionsTypeId = '8'
                    question.mustanswer = false
                    question.logicalSettings = logicalSettings2
                    question.scoreOrNot = 0
                    question.isClosedLoop = 0
                }
                quesinfoArr.splice(index, 1)
            }
        })

        // 添加‘其他’选项
        quesinfoArr.forEach((info, index) =>{
            if(question.questionsTypeId == '8' || question.questionsTypeId == '10') {
                let option = new Option()
                option.oid = UUID()
                if(info.indexOf(`【${_this.$t('main.TextFilling')}】`) !== -1){
                    option.labelName = info.replace(`【${_this.$t('main.TextFilling')}】`, '')
                    option.haveInput = true
                } else {
                    option.labelName = info
                    option.haveInput = false
                }
                option.inputValue = ''
                option.minNum = 0
                option.maxNum = 0
                option.decimalPlaces = 0
                question.optionList.push(option)
            }
        })
        if(question.questionsTypeId == '12'){
            for(let i = 0; i < 2; i++){
                let option = new Option()
                option.oid = UUID()
                question.optionList.push(option)
            }
            question.optionList[0].labelName = _this.$t('main.Correct')
            question.optionList[1].labelName = _this.$t('main.Error')
        }

        // 题号（所有question需要quesIndex,逻辑需要使用）
        let index = 0
        this.questionsList.forEach((item) => {
            index++
        })
        question.quesIndex = index
        this.quesCount++

        // 添加问题标签
        setLabelName(question)

        this.questionsList.push(question)
    }
}

// 添加问题标签
const setLabelName = function(question) {
    let name = question.questionsName
    let arr = name.match(/【ProblemLabel：(\S*)】/)
    if (arr) {
        question.questionsName = name.replace(arr[0], '')
        question.quesLabelName = arr[1]
    }
}

// 试题特有属性
const Question = function () {
    this.quesCode = ''
    this.qid = 0; // 试题id
    this.isedit = false // 新添加的问题设置为编辑状态
    this.questionsTypeId = ""; // 试题类型
    this.questionsName = ""; // 试题名称
    this.mustanswer = true; //是否必填
    this.isShow = true
    this.bindIsShow = true
    this.optionList = new Array();
    this.questionsSonList = new Array();
}

const Option = function() {
	this.oid = 0
    this.labelName=''
}
export {
    Paper,
    Question,
    Option
} 